/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import {
  OnInit,
  ViewEncapsulation,
  ViewChild,
  Component,
  OnDestroy
} from '@angular/core';
import { FittingSizeDataService } from '../../sharedServices/fittingSize-data.service';
import { FittingSizeManagementService } from '../../sharedServices/fitting-size-management.service';
import { Subscription, Subject } from 'rxjs';
import { GenericTableData } from '../../sharedServices/generic-table-data.service';
import { AuthentificationService } from '../../sharedServices/authentification.service';
import { DialogBoxComponent } from '../../shared/dialog-box/dialog-box.component';
import { UserHandlerService } from '../../sharedServices/user-handler.service';
import { LoaderService } from '../../sharedServices/loader.service';
import { FittingsManagementService } from 'api/services';
import { ActionPageEnumDto, ActionTypeEnumDto, FittingDto } from 'api/models';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'app-add-fitting-size',
  templateUrl: './add-fitting.component.html',
  encapsulation: ViewEncapsulation.None
})
export class AddFittingComponent implements OnInit, OnDestroy {

  constructor(
    public dialog: MatDialog,
    public userHandlerService: UserHandlerService,
    public fittingsManagementService: FittingsManagementService,
    public genericTableDataService: GenericTableData,
    public fittingSizeDataService: FittingSizeDataService,
    public fittingSizeManagementService: FittingSizeManagementService,
    public authentificationService: AuthentificationService,
    public loaderService: LoaderService
  ) {
    this.loaderService.display(true);
  }
  refreshSubscription: Subscription;
  resetExistingTableSubject: Subject<boolean> = new Subject<boolean>();
  contextSelectedFitting;
  onAddContextMenuPosition = { x: '0px', y: '0px' };
  element: any;
  actionPage: ActionPageEnumDto;
  actionType: ActionTypeEnumDto;
  isFittingTable: boolean;
  isAddedFittingSizesExpended = false;
  isExistingFittingSizesExtended = false;
  selectedRowCopy;


  @ViewChild(MatMenuTrigger)
  onAddContextMenu: MatMenuTrigger;

  columnHeader: any = {
    fittingEntryID: 'Fitting Entry ID',
    manufacturerName: 'Manufacturer Name',
    productLineName: 'ProductLine Name',
    longDescription: 'Long Description',
    fileName: 'File Name ',
    status: 'Status',
    requestBy: 'Request By',
    componentGroup: 'Component Group',
    productDiscipline: 'Product Discipline',
    subProductName: 'SubProduct Name',
    materialAbrv: 'Material Abrveviation',
    materialName: 'Material Name',
    manufAbrv: 'Manufacturer Abreviation',
    valveClass: 'Valve Class',
    schedule: 'Schedule',
    installType: 'Install Type',
    unitsName: 'Units Name'
  };

  existingFittingscolumnHeaderPippingImperial = {
    bdid: 'BDID',
    nominalSize: 'Nominal Size',
    weightImperial: 'Weight Imperial',
    weightMetric: 'Weight Metric',
    orderNumber: 'Order Number',
    startPage: 'Start Page',
    endPage: 'End Page',
    decSize1: 'Dec Size 1',
    decSize2: 'Dec Size 2',
    decSize3: 'Dec Size 3',
    decSize4: 'Dec Size 4',
    decSize5: 'Dec Size 5',
    decSize6: 'Dec Size 6',
    hpid: 'HPID',

  };

  existingFittingscolumnHeaderPippingMetric = {
    bdid: 'BDID',
    nominalSize: 'Nominal Size',
    weightImperial: 'Weight Imperial',
    weightMetric: 'Weight Metric',
    orderNumber: 'Order Number',
    startPage: 'Start Page',
    endPage: 'End Page',
    decSize1: 'Dec Size 1',
    decSize2: 'Dec Size 2',
    decSize3: 'Dec Size 3',
    decSize4: 'Dec Size 4',
    decSize5: 'Dec Size 5',
    decSize6: 'Dec Size 6',
    amtechID: 'AmtechID',
  };

  existingFittingSizesCableTray = {
    BDID: 'BDID',
    NominalSize: 'Nominal Size',
    DecWidth1: 'Dec Width 1',
    DecDepth1: 'Dec Depth 1',
    DecWidth2: 'Dec Width 2',
    DecDepth2: 'Dec Depth 2',
    DecWidth3: 'Dec Width 3',
    DecDepth3: 'Dec Depth 3',
    DecWidth4: 'Dec Width 4',
    DecDepth4: 'Dec Depth 4',
    DecWidth5: 'Dec Width 5',
    DecDepth5: 'Dec Depth 5',
    DecWidth6: 'Dec Width 6',
    DecDepth6: 'Dec Depth 6',
    StartPage: 'Start Page',
    EndPage: 'End Page',

  };

  existingFittingscolumnHeaderSheetMetal = {
    bdid: 'BDID',
    nominalSize: 'Nominal Size',
    decSize: 'Dec Size',
    sizeID: 'Size ID',

  };

  ngOnInit() {
    this.refreshSubscription = this.fittingSizeManagementService
      .getFittingTableData()
      .subscribe(() => {
        this.refresh();
        this.selectedRowCopy = this.fittingSizeManagementService.getSelectedRowCopy();
      });
    this.actionPage = ActionPageEnumDto.Add;
    this.actionType = ActionTypeEnumDto.UndoAdd;
    this.resetExistingFittingSizeDataTable();
    this.setTableHeaders();
    this.getFittingsData();
    this.fittingSizeManagementService.setActionPage(this.actionPage);

  }

  ngOnDestroy(): void {
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
    this.fittingSizeManagementService.setMapperType(null);
    this.selectedRowCopy = undefined;
  }

  expandAddedFittingSizezComponent() {
    this.isAddedFittingSizesExpended = !this.isAddedFittingSizesExpended;
  }

  expandExistingFittingSizezComponent() {
    this.isExistingFittingSizesExtended = !this.isExistingFittingSizesExtended;
  }

  resetExistingSizesTable() {
    this.resetExistingTableSubject.next(true);
  }

  refresh() {
    this.getFittingsData(false);
    this.setTableHeaders();
  }

  getFittingsData(stopLoadSpinner = true) {
    this.fittingsManagementService.getFittingsByAssignedAction(
      {
        userId: this.userHandlerService.getCurrentUserId(),
        actionPageDto: this.actionPage
      }
    )
      .subscribe(result => {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        result.forEach(() => {
        });
        this.genericTableDataService.setTableDataList(result);
            /* istanbul ignore if */
        if (stopLoadSpinner) {
          this.loaderService.display(false);
        }

      });
  }

  getExistingFittingSizes(fitting: FittingDto, turnOffSpinner = false) {
    this.selectedRowCopy = this.fittingSizeManagementService.getSelectedRowCopy();
    this.fittingSizeManagementService.setMapperType(fitting);
    this.loaderService.display(true);
    switch (fitting.productDisciplineID) {
      case 2: {
        this.setHeadersByUnitId();
        this.fittingsManagementService.getPipeFittingSize({ fittingDefinitionId: fitting.fittingEntryID })
          .subscribe(data => {
            this.fittingSizeDataService.setTableDataList(data);
                /* istanbul ignore if */
            if (turnOffSpinner) {
              this.loaderService.display(false);
            }
          });
        break;
      }
      case 4: {
        this.setHeadersByUnitId();
        this.fittingsManagementService.getElectricalFittingSize({ fittingDefinitionId: fitting.fittingEntryID })
          .subscribe(data => {
            this.fittingSizeDataService.setTableDataList(data);
                /* istanbul ignore if */
            if (turnOffSpinner) {
              this.loaderService.display(false);
            }

          });
        break;
      }
      case 5: {
        this.fittingSizeDataService.setTableHeader(
          this.existingFittingscolumnHeaderSheetMetal
        );
        this.fittingsManagementService.getSheetMetalFittingSize({ fittingDefinitionId: fitting.fittingEntryID })
          .subscribe(data => {
            this.fittingSizeDataService.setTableDataList(data);
                /* istanbul ignore if*/
            if (turnOffSpinner) {
              this.loaderService.display(false);
            }

          });
        break;
      }
      case 9: {
        this.fittingSizeDataService.setTableHeader(
          this.existingFittingSizesCableTray
        );
        this.fittingsManagementService.getCableTrayFittingSize({ fittingDefinitionId: fitting.fittingEntryID })
          .subscribe(data => {
            this.fittingSizeDataService.setTableDataList(data);
                /* istanbul ignore if */
            if (turnOffSpinner) {
              this.loaderService.display(false);
            }

          });
        break;
      }
    }

    this.resetExistingSizesTable();
    this.fittingSizeManagementService.refreshComponent();

  }


  verifySelectedFitting() {
    return (
      this.contextSelectedFitting ===
      this.fittingSizeManagementService.getSelectedFitting()
    );
  }

  onAddContextMenuClick(event) {
    this.contextSelectedFitting = event.element;
     if (this.onAddContextMenu !== undefined) {
      this.onAddContextMenuPosition.x = event.mouseEvent.clientX + 'px';
      this.onAddContextMenuPosition.y = event.mouseEvent.clientY + 'px';
      this.onAddContextMenu.menuData = { element: event.element };
      this.onAddContextMenu.openMenu();
    }
  }

  onUndoActionClick(element: FittingDto) {
    const dialogRef = this.dialog.open(DialogBoxComponent, {
      data: {
        title: 'Undo action',
        message: 'Do you want to undo this fitting?',
        addComment: true
      }
    });
    this.handleUndoActionButton(dialogRef, element);
  }

  handleUndoActionButton(
    dialogRef: MatDialogRef<DialogBoxComponent, any>,
    element
  ) {
    const subscribeOk = dialogRef.componentInstance.okClickEvent.subscribe(
      () => {
            /* istanbul ignore if */
        if (dialogRef.componentInstance.data.addComment) {
          this.onUndoAction(element, dialogRef.componentInstance.data.comment);
        }
      }
    );
    dialogRef.afterClosed().subscribe(() => {
      subscribeOk.unsubscribe();
    });
  }

  onUndoAction(element: FittingDto, comment: string) {
    this.loaderService.display(true);
    this.fittingsManagementService.undoFittingRequest({
      userId: this.userHandlerService.getCurrentUserId(),
      bdToolId: element.bdToolID,
      actionTypeEnumDto: this.actionType,
      fittingEntryId: element.fittingEntryID,
      comment
    }).subscribe(() => {
      this.fittingSizeManagementService.openSnackBar('The fitting was undid successfully');
      this.resetExistingFittingSizeDataTable();
      this.getFittingsData();
    });
  }

  resetExistingFittingSizeDataTable() {
    this.fittingSizeDataService.setTableDataList(null);
  }

  setTableHeaders() {
    this.genericTableDataService.setTableHeader(this.columnHeader);
    this.fittingSizeDataService.setTableHeader(
      this.existingFittingscolumnHeaderPippingImperial
    );
  }

  isFittingSentForApprove(): boolean {
    return (
      this.getFittingType() &&
      this.fittingSizeManagementService.hasFittingBeenSentToApprove()
    );
  }

  getFittingType() {
    return this.fittingSizeManagementService.getSelectedFittingType();
  }

  getPartialSaveActionType() {
    return ActionTypeEnumDto.PartialSaveAdd;
  }

  getSentForAproveActionType() {
    return ActionTypeEnumDto.SendForApproveAdd;
  }

  getDeleteActionType() {
    return ActionTypeEnumDto.RemoveAddedAfterPartialSave;
  }

  setHeadersByUnitId(){
    if(this.fittingSizeManagementService.selectedFitting.unitID === 1){
      this.fittingSizeDataService.setTableHeader(
        this.existingFittingscolumnHeaderPippingImperial
      );
    }
    else{
      this.fittingSizeDataService.setTableHeader(
        this.existingFittingscolumnHeaderPippingMetric
      );
    }
  }
}
